import * as types from './actionTypes';
import {renuevaTokenAccion} from '../util';
import toastr from 'toastr';


export function renueva(user) {
  return {type: types.RENOVAR_SESSION, datos:user};
}



export function renuevaSessionUser(){
    return dispatch => {
     return renuevaTokenAccion(this).then( (user)=>{ 
        dispatch(renueva(user));
    })
    .catch(error=>{
      toastr.info("Registrate para participar en los cursos.");
         dispatch(renueva(null));
    });
        };
	
}

export function initTimer() {
  return {type: types.INIT_TIMER};
}

export function addUser(user){
	return {type: types.ADD_TOKEN, datos:user};
}


export function setPaginaActual(pagina){
    return {type: types.SET_PAGINA_ACTUAL, datos:pagina};
}